import type { NotificationBasicConfig } from '@/interfaces/context/INotification.context';

type NotificationContent = {
	title: string;
	content: string;
	btn: {
		accept?: string;
		cancel?: string;
	};
};

export const notifications = (
	content: NotificationContent,
	onConfirm?: () => void,
): {
	confirm: NotificationBasicConfig;
	success: NotificationBasicConfig;
	error: NotificationBasicConfig;
} => ({
	confirm: {
		title: content.title,
		content: content.content,
		buttons: (closeNotification: () => void) => [
			{
				key: 'cancel',
				label: content.btn.cancel,
				mode: 'tertiary',
				size: 'size-40',
				onClick: closeNotification,
			},
			{
				key: 'accept',
				label: content.btn.accept,
				size: 'size-40',
				onClick() {
					closeNotification();
					if (onConfirm) {
						onConfirm();
					}
				},
			},
		],
	},
	success: {
		title: content.title,
		content: content.content,
		buttons: (closeNotification: () => void) => [
			{
				key: 'accept',
				label: content.btn.accept,
				size: 'size-40',
				minWidth: '150',
				onClick() {
					closeNotification();
				},
			},
		],
	},
	error: {
		title: content.title,
		content: content.content,
		buttons: (closeNotification: () => void) => [
			{
				key: 'accept',
				label: content.btn.accept,
				size: 'size-40',
				minWidth: '150',
				onClick() {
					closeNotification();
				},
			},
		],
	},
});
